(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pq-account-drawer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('pq-account-drawer')) {
      customElements.define(
        'pq-account-drawer',
        class PqAccountDrawer extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          static get observedAttributes() {
            return ['data-type'];
          }
          attributeChangedCallback(name, oldValue, newValue) {
            if (name === 'data-type') {
              this.initType(newValue);
            }
          }
          init() {
            this.initClose();
            this.initPassword();
          }
          async initPassword() {
            // 如果页面路径中是type=rese并且sign和email有值，就显示重置密码页面
            const urlParams = new URLSearchParams(window.location.search);
            const type = urlParams.get('type');
            const sign = urlParams.get('sign');
            const email = urlParams.get('email');
            if (type === 'reset' && sign && email) {
              window.pq.openAccountDrawer('reset');
            }
            if (type === 'setup' && sign && email) {
              try {
                const res = await this.verifySetupSign({ sign });
                if (res.code === 200) {
                  window.pq.openAccountDrawer('setup');
                }
              } catch (error) {
                window.pq.openAccountDrawer('setup', 'invalid');
              }
            }
          }
          async verifySetupSign(data) {
            const url = '/shopify/auth/invite/check';
            const res = await window.pq.http.post(url, {
              data,
            });
            if (res.code === 200) {
              return res;
            } else if (res.code === 10101107) {
              throw new Error(window.pqI18n.error_10101107);
            } else if (res.code === 10101110) {
              throw new Error(window.pqI18n.error_10101404);
            } else if (res.code === 10101108) {
              throw new Error(window.pqI18n.error_10101108);
            } else {
              throw new Error(window.pqI18n.error_request_failed);
            }
          }
          initClose() {
            const pqAccountDrawerClose = this.querySelector('.pq-account-drawer__container-header-close');
            const pqAccountDrawerHeaderMobileIcon = this.querySelector(
              '.pq-account-drawer__container-header-mobile-icon'
            );
            if (pqAccountDrawerClose) {
              pqAccountDrawerClose.addEventListener('click', () => {
                window.pq.closeAccountDrawer();
              });
            }
            if (pqAccountDrawerHeaderMobileIcon) {
              pqAccountDrawerHeaderMobileIcon.addEventListener('click', () => {
                window.pq.closeAccountDrawer();
              });
            }
          }
          initType(type) {
            const pqAccountDrawerContentItem = this.querySelectorAll('.pq-account-drawer__container-content-item');
            pqAccountDrawerContentItem.forEach((item) => {
              item.classList.remove('active');
            });
            const pqAccountDrawerContentItemActive = this.querySelector(
              `.pq-account-drawer__container-content-item[data-type="${type}"]`
            );
            pqAccountDrawerContentItemActive?.classList.add('active');
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pq-account"]) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('pq-account')) {
      customElements.define(
        'pq-account',
        class MainCustomersAccountNew extends HTMLElement {
          constructor() {
            super();
            this.currentPosition = 0;
          }
          connectedCallback() {
            this.init();
            if (window.pq && window.pq.eventBus && typeof window.pq.eventBus.subscribe === 'function') {
              window.pq.eventBus.subscribe('account:switchTab', (res) => {
                this.switchTab(res);
              });
              window.pq.eventBus.subscribe('account:updateBreadcrumb', (tab) => {
                this.updateBreadcrumb(tab);
              });
              window.pq.eventBus.subscribe('account:updateAvatar', (data) => {
                this.updateAvatar(data);
              });
            }
          }
          init() {
            this.initTabs();
            this.initPage();
            this.updateAvatar();
          }
          initPage() {
            const url = window.location.href;
            const urlObj = new URL(url);
            const type = urlObj.searchParams.get('type');
            if (type) {
              this.switchTab(type);
            }
          }
          updateAvatar() {
            const customer = window.pq.getLocalStorage('pqUserInfo');
            const avatarContainer = this.querySelector('.pq-account__left-profile-mobile-avatar-container');
            if (customer.avatarLink) {
              avatarContainer.setAttribute('data-has-avatar', 'true');
            } else {
              avatarContainer.setAttribute('data-has-avatar', 'false');
            }
            const avatarImage = this.querySelector('.pq-account__left-profile-mobile-avatar-image');
            if (avatarImage) {
              avatarImage.src = customer.avatarLink;
            }
          }
          updateBreadcrumb(tab) {
            const secondItem = this.querySelector('.pq-account__breadcrumb-second');
            const thirdItem = this.querySelector('.pq-account__breadcrumb-third');
            if (!secondItem || !thirdItem) return;
            const titles = {
              profile: (window.pqI18n && window.pqI18n.my_profile) || 'My Profile',
              address: (window.pqI18n && window.pqI18n.my_address) || 'My Address',
              orders: (window.pqI18n && window.pqI18n.my_order) || 'My Order',
              'order-detail': (window.pqI18n && window.pqI18n.order_details) || 'Order Details',
            };
            const secondTitleEl = secondItem.querySelector('.pq-account__breadcrumb-title');
            const thirdTitleEl = thirdItem.querySelector('.pq-account__breadcrumb-title');
            if (tab === 'order-detail') {
              if (secondTitleEl) secondTitleEl.textContent = titles.orders;
              secondItem.setAttribute('data-active', 'false');
              thirdItem.setAttribute('data-active', 'true');
              if (thirdTitleEl) thirdTitleEl.textContent = titles['order-detail'];
            } else {
              if (secondTitleEl) secondTitleEl.textContent = titles[tab] || tab;
              secondItem.setAttribute('data-active', 'true');
              thirdItem.setAttribute('data-active', 'false');
            }
          }
          switchTab(tab) {
            if (!tab) return;
            if (tab === 'overview') {
              this.setAttribute('data-type', 'default');
              if (window.innerWidth <= 1024) {
                // ✅ 2. 滚动到记录的位置
                window.scrollTo({
                  top: this.currentPosition || 0,
                  behavior: 'auto', // 或 'smooth'
                });
              }
              return;
            } else {
              this.setAttribute('data-type', 'dialog');
            }
            const tabs = this.querySelectorAll('.pq-account__left-item');
            const rightItems = this.querySelectorAll('.pq-account__right-item');
            tabs.forEach((t) => {
              t.setAttribute('data-active', 'false');
            });
            rightItems.forEach((item) => {
              item.setAttribute('data-active', 'false');
            });
            const currentTab = this.querySelector('.pq-account__left-item[data-tab="' + tab + '"]');
            const currentRightItem = this.querySelector('.pq-account__right-item[data-tab="' + tab + '"]');
            if (currentTab) currentTab.setAttribute('data-active', 'true');
            if (currentRightItem) currentRightItem.setAttribute('data-active', 'true');

            this.updateBreadcrumb(tab);

            if (tab === 'address') {
              // 只修改地址为/account/addresses，去除参数，不刷新页面
              const url = window.location.href;
              const urlObj = new URL(url);
              urlObj.pathname = '/account/addresses';
              urlObj.searchParams.delete('type');
              window.history.replaceState({}, '', urlObj.toString());
            } else {
              // 修改页面地址为/account?type=currentTab
              const url = window.location.href;
              const urlObj = new URL(url);
              urlObj.pathname = '/account';
              urlObj.searchParams.set('type', tab);
              window.history.replaceState({}, '', urlObj.toString());
            }
          }
          initTabs() {
            const tabs = this.querySelectorAll('.pq-account__left-item');
            const rightItems = this.querySelectorAll('.pq-account__right-item');
            tabs.forEach((tab) => {
              tab.addEventListener('click', () => {
                this.currentPosition = window.scrollY || window.pageYOffset;
                // if (window.pq && window.pq.eventBus && typeof window.pq.eventBus.publish === 'function') {
                //   window.pq.eventBus.publish('account:closeEdit', true);
                // }
                const action = tab.getAttribute('data-action');
                const currentTab = tab.getAttribute('data-tab');
                if (action === 'switch') {
                  rightItems.forEach((item) => {
                    item.setAttribute('data-active', 'false');
                  });
                  const currentRightItem = this.querySelector('.pq-account__right-item[data-tab="' + currentTab + '"]');
                  if (currentRightItem) currentRightItem.setAttribute('data-active', 'true');
                  tabs.forEach((t) => {
                    t.setAttribute('data-active', 'false');
                  });
                  tab.setAttribute('data-active', 'true');
                  this.updateBreadcrumb(currentTab);
                  // 特殊处理
                  if (currentTab === 'address') {
                    // 只修改地址为/account/addresses，去除参数，不刷新页面
                    const url = window.location.href;
                    const urlObj = new URL(url);
                    urlObj.pathname = '/account/addresses';
                    urlObj.searchParams.delete('type');
                    window.history.replaceState({}, '', urlObj.toString());
                    this.setAttribute('data-type', 'dialog');
                  } else if (currentTab === 'profile') {
                    // 只修改地址为/account/addresses，去除参数，不刷新页面
                    const url = window.location.href;
                    const urlObj = new URL(url);
                    urlObj.pathname = '/account';
                    urlObj.searchParams.set('type', currentTab);
                    window.history.replaceState({}, '', urlObj.toString());
                    this.setAttribute('data-type', 'dialog');
                    const navEditIcon = document.querySelector('.account-profile-nav-right-item');
                    if (navEditIcon) {
                      navEditIcon.classList.remove('hidden');
                    }
                  } else {
                    // 修改页面地址为/account?type=currentTab
                    const url = window.location.href;
                    const urlObj = new URL(url);
                    urlObj.pathname = '/account';
                    urlObj.searchParams.set('type', currentTab);
                    window.history.replaceState({}, '', urlObj.toString());
                    this.setAttribute('data-type', 'dialog');
                  }
                }
              });
            });
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pq-member-banner"] && !Shopify.designMode) return;
  try {
    
  // 简单的 Modal 控制器实现
  class ModalController {
    constructor() {
      this.modals = new Map();
    }

    getModal(id) {
      return this.modals.get(id);
    }

    register(id, options = {}) {
      // 查找 global-modal 组件
      const modal = document.querySelector(`global-modal[data-modal-id="${id}"]`);
      if (!modal) return null;

      this.modals.set(id, modal);

      // 注册事件监听
      if (options.onOpen) {
        modal.addEventListener('modal-opened', (event) => {
          options.onOpen(event.detail.wrapperEle);
        });
      }
      if (options.onClose) {
        modal.addEventListener('modal-closed', (event) => {
          options.onClose(event.detail.wrapperEle);
        });
      }

      return modal;
    }

    open(id) {
      const modal = this.modals.get(id);
      if (modal && typeof modal.open === 'function') {
        modal.open();
      }
    }

    close(id) {
      const modal = this.modals.get(id);
      if (modal && typeof modal.close === 'function') {
        modal.close();
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    // 检查自定义元素是否已定义
    if (!customElements.get('pq-program-banner')) {
      customElements.define(
        'pq-program-banner',
        class pqProgramBanner extends HTMLElement {
          constructor() {
            super();
            window.pq = window.pq || {};
            window.pq.ModalControllerState = window.pq.ModalControllerState || new ModalController();
            this.modalManager = window.pq.ModalControllerState;
            this.activityContainer = null;
            this.rewardsContainer = null;
            this.firstOpen = true;
            this.memberBannerRewardsTabs = null;
            this.code = null;
            this.isInitialized = false; // 标记是否已初始化
            this.pageshowHandler = null; // 保存 pageshow 事件处理函数
            this.token =
              'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1aWQiOjkwMDAwMTY4MywiYWNjZXNzIjoiYWNjZXNzIiwiZXhwIjoxOTAwODA4NTgyfQ.6hdmN-fLW-pOBoQQsGn1DO2JmV8odkekYh2_aH4Rwak';
          }
          async connectedCallback() {
            // 防止重复初始化
            if (this.isInitialized) {
              return;
            }
            this.isInitialized = true;

            this.initModal();
            this.init();
            console.log('触发');

            window.pq.eventBus.subscribe('CHANGE_USER_POINTS_DATA', (res) => {
              this.updateUserPoints(res);
              window.pq.eventBus.publish('RENDER_REDEEM_LIST', res.currentPoint);
            });
            // 更改头像
            if (window.customer) {
              const avatarContainer = this.querySelector('.avatar-container');
              const ltUserInfo = window.pq.getLocalStorage('ltUserInfo');
              if (avatarContainer && ltUserInfo?.avatarLink) {
                const userInfoEmail = avatarContainer.querySelector('.user-info-email');
                const userInfoEmailImg = avatarContainer.querySelector('.user-info-email-img');
                if (userInfoEmail) {
                  userInfoEmail.classList.add('hidden');
                }
                if (userInfoEmailImg) {
                  userInfoEmailImg.classList.remove('hidden');
                  userInfoEmailImg.setAttribute('src', ltUserInfo.avatarLink);
                }
              }

              this.getMemberPoints()
                .then((res) => {
                  this.updateUserPoints(res);
                  window.pq.eventBus.publish('RENDER_REDEEM_LIST', res.currentPoint);
                })
                .catch((error) => {
                  if (window.pq?.showToast) {
                    window.pqToast.showToast('error', window.i18n.request_failed);
                  }
                });
            }

            const memberRedeemModalClose = this.querySelector('.member-redeem-modal-close');
            if (memberRedeemModalClose) {
              memberRedeemModalClose.addEventListener('click', () => {
                this.closeModal();
              });
            }

            const memberRedeemModalBtnCopyWrapper = this.querySelector('.member-redeem-modal-btn-copy');
            const memberRedeemModalBtnCopy = memberRedeemModalBtnCopyWrapper?.querySelector('button');
            if (memberRedeemModalBtnCopy) {
              memberRedeemModalBtnCopy.addEventListener('click', () => {
                this.copy();
              });
            }

            const pqMemberBannerButtonRegister = this.querySelector('.pq-member-banner__button-register');
            const pqMemberBannerButtonLogin = this.querySelector('.pq-member-banner__button-login');

            if (pqMemberBannerButtonRegister) {
              pqMemberBannerButtonRegister.addEventListener('click', function () {
                window.pq.openAccountDrawer('login-register', 'register');
              });
            }

            if (pqMemberBannerButtonLogin) {
              pqMemberBannerButtonLogin.addEventListener('click', function () {
                window.pq.openAccountDrawer('login-register', 'login');
              });
            }
          }

          disconnectedCallback() {
            // 清理事件监听器
            if (this.pageshowHandler) {
              window.removeEventListener('pageshow', this.pageshowHandler);
              this.pageshowHandler = null;
            }
            this.isInitialized = false;
          }

          updateUserPoints(res) {
            try {
              window.pq.userPointData = JSON.parse(JSON.stringify(res));
              const memberInfo = this.querySelector('.member-banner__user-info');
              if (memberInfo) {
                memberInfo.classList.remove('hidden');
                memberInfo.classList.add('flex');
              }
              // 获取member-tier
              const memberTier = this.querySelector('.member-tier');
              // 获取member-point
              const memberPoint = this.querySelector('.member-point');
              // 获取member-need-points
              const memberNeedPoints = this.querySelector('.member-need-points');
              // 获取 pq-member-banner-member-content-left 元素
              const memberContentLeft = this.querySelector('.pq-member-banner-member-content-left');

              if (memberTier) {
                memberTier.textContent = res.settingName || '--';
              }
              if (memberPoint) {
                memberPoint.textContent = res.currentPoint;
              }

              if (!(memberNeedPoints && res?.nextSettingValue && res?.nextSettingNam)) {
                memberContentLeft.classList.add('pq-member-banner-member-content-left-type-2');
              }

              if (memberNeedPoints && res.nextSettingValue && res.nextSettingName) {
                // 显示进度条区域
                const pointsWrapper = this.querySelector('.pq-member-banner-progress');
                if (pointsWrapper) {
                  pointsWrapper.classList.remove('hidden');
                }
                const spans = memberNeedPoints.querySelectorAll('span');
                if (spans.length > 0) {
                  if (res.settingType === 2) {
                    const nextSettingName = memberNeedPoints.querySelector('.nextSettingName');
                    const upgradePoints = memberNeedPoints.querySelector('.upgradePoints');
                    if (nextSettingName) {
                      nextSettingName.textContent = res.nextSettingName;
                    }
                    if (upgradePoints) {
                      upgradePoints.textContent = res.nextSettingValue - res.currentPoint;
                    }
                  } else {
                    const nextSettingName = memberNeedPoints.querySelector('.nextSettingName');
                    const upgradePoints = memberNeedPoints.querySelector('.upgradePoints');
                    if (nextSettingName) {
                      nextSettingName.textContent = res.nextSettingName;
                    }
                    if (upgradePoints) {
                      upgradePoints.textContent = Math.floor(res.nextSettingValue - Math.floor(res.totalAmount));
                    }
                  }
                } else {
                  if (res.settingType === 2) {
                    // 获取memberNeedPoints文本
                    const memberNeedPointsText = memberNeedPoints.textContent;
                    memberNeedPoints.innerHTML = memberNeedPointsText
                      .replace(
                        /\{\{ tier \}\}/g,
                        `<span class="text-primary nextSettingName">${res.nextSettingName}</span>`
                      )
                      .replace(
                        /\{\{ points \}\}/g,
                        `<span class="text-primary upgradePoints">${res.nextSettingValue - res.currentPoint}</span>`
                      );
                  } else {
                    const memberNeedPointsText = memberNeedPoints.getAttribute('data-max-points');
                    memberNeedPoints.innerHTML = memberNeedPointsText
                      .replace(
                        /\{\{ dollar \}\}/g,
                        `<span class="text-primary upgradePoints">${Math.floor(
                          res.nextSettingValue - Math.floor(res.totalAmount)
                        )}</span>`
                      )
                      .replace(
                        /\{\{ level \}\}/g,
                        `<span class="text-primary nextSettingName">${res.nextSettingName}</span>`
                      );
                  }
                }
                const memberPointCurrent = this.querySelector('.member-point-current');
                const memberPointTotal = this.querySelector('.member-point-total');
                if (memberPointCurrent && memberPointTotal) {
                  if (res.settingType === 2) {
                    memberPointCurrent.textContent = res.currentPoint;
                    memberPointTotal.textContent = res.nextSettingValue;
                  } else {
                    memberPointCurrent.textContent = Math.floor(res.totalAmount);
                    memberPointTotal.textContent = res.nextSettingValue;
                  }
                }
                // 获取member-progress
                const memberProgress = document.querySelector('.pq-member-banner-progress-bar-fill');
                if (memberProgress) {
                  if (res.settingType === 2) {
                    console.log('222222', `${Math.min(100, (res.currentPoint / res.nextSettingValue) * 100)}%`);

                    memberProgress.style.setProperty(
                      '--progress',
                      `${Math.min(100, (res.currentPoint / res.nextSettingValue) * 100)}%`
                    );
                  } else {
                    console.log('111111', `${Math.min(100, (res.currentPoint / res.nextSettingValue) * 100)}%`);

                    memberProgress.style.setProperty(
                      '--progress',
                      `${Math.min(100, (res.totalAmount / res.nextSettingValue) * 100)}%`
                    );
                  }
                }
              } else {
                const maxLevelWrapper = document.querySelector('.member-banner_max_level_wrapper');
                const pointsWrapper = document.querySelector('.pq-member-banner-progress');
                if (maxLevelWrapper) {
                  maxLevelWrapper.classList.remove('hidden');
                  const maxLevelText = maxLevelWrapper.textContent;
                  maxLevelWrapper.innerHTML = maxLevelText.replace(/\{\{ level \}\}/g, res.settingName);
                }
                if (pointsWrapper) {
                  pointsWrapper.classList.add('hidden');
                }
              }

              const memberLevelTableWrapper = document.querySelector('.pq-member-level__table-wrapper');
              const memberLevel = document.querySelector('.pq-member-level');
              memberLevel.querySelectorAll(`[data-memberSettingId="${res.settingId}"]`).forEach((item) => {
                item.classList.add('user-benefit_active');
                const newElement = document.createElement('div');
                newElement.classList.add('pq-member-level__th-current-level');
                const theadItem = document.querySelector('.pq-member-level__thead .user-benefit_active');
                theadItem.appendChild(newElement);
                theadItem.querySelector('.pq-member-level__th-current-level').textContent =
                  this.getAttribute('data-current-level-text');
                // 获取item 距离memberLevelTableWrapper的距离
                let diff = 0;
                if (window.innerWidth > 576) {
                  diff = 320;
                } else {
                  diff = 150;
                }
                const itemOffset = item.offsetLeft - diff;
                memberLevelTableWrapper.scrollLeft = itemOffset;
              });
            } catch (error) {
              // 静默处理错误
            }
          }

          copy() {
            window.pq.copyToClipboard(this.code);
            // 跳转到首页
            window.location.href = '/';
          }

          // 获取会员积分信息
          async getMemberPoints() {
            const url = '/shopify/user/point?t=' + new Date().getTime();
            const { data, code } = await window.pq.http.get(url);
            if (code === 200) {
              return data;
            } else {
              return null;
            }
          }

          // 获取会员奖励列表
          async getMemberRewards(data) {
            const url = '/shopify/user/page/discount';
            const res = await window.pq.http.get(url, {
              data,
            });
            if (res.code === 200) {
              return res.data;
            } else {
              throw new Error(window.i18n.error_message_timeout);
            }
          }

          // 获取会员日志
          async getMemberLogs() {
            const url = '/shopify/user/pointLog';
            const res = await window.pq.http.get(url);
            if (res.code === 200) {
              return res.data;
            } else {
              throw new Error(window.i18n.error_message_timeout);
            }
          }

          showButtonLoading(button) {
            if (button) {
              button.classList.add('loading');
            }
          }

          hideButtonLoading(button) {
            if (button) {
              button.classList.remove('loading');
            }
          }

          init() {
            const _this = this;
            const rewardBtn = this.querySelector('.reward-btn');
            const activityBtn = this.querySelector('.activity-btn');

            this.rewardsContainer = this.modalManager.getModal('member_banner_rewards_modal');

            rewardBtn?.addEventListener('click', async () => {
              try {
                const rewardBtn_button = rewardBtn.querySelector('button');
                this.showButtonLoading(rewardBtn_button);
                const res = await this.getMemberRewards({
                  page: 1,
                  pageSize: 999,
                  status: 0,
                });
                this.memberBannerRewardsTabs = 'available';
                const dataRewardTab = Array.from(this.rewardsContainer.querySelectorAll('[data-reward-tab]'));
                dataRewardTab.forEach((tab) => {
                  tab.classList.remove('active-tab');
                });
                if (dataRewardTab[0]) {
                  dataRewardTab[0].classList.add('active-tab');
                }

                this.renderRewardsContent('available', res);
                this.modalManager.open('member_banner_rewards_modal');
                this.hideButtonLoading(rewardBtn_button);
              } catch (error) {
                if (rewardBtn_button) {
                  this.hideButtonLoading(rewardBtn_button);
                }
                window.pqToast.showToast('error', window.i18n.request_failed);
              }
            });
            activityBtn?.addEventListener('click', async (event) => {
              // 阻止事件冒泡，避免触发父元素 reward-btn 的点击事件
              event.stopPropagation();
              const activityBtn_button = activityBtn.querySelector('button');
              this.showButtonLoading(activityBtn_button);
              try {
                const res = await this.getMemberLogs();
                // 获取 modal 元素，然后查找内部的内容容器
                const modal = this.modalManager.getModal('activity-modal');
                this.activityContainer = modal?.querySelector('.global-modal__wrapper') || null;

                if (!this.activityContainer) {
                  // 如果还没有注册，先注册
                  this.modalManager.register('activity-modal', {
                    onOpen: (container) => {
                      this.activityContainer = container;
                    },
                    onClose: () => {},
                  });
                  const modalAfterRegister = this.modalManager.getModal('activity-modal');
                  this.activityContainer = modalAfterRegister?.querySelector('.global-modal__wrapper') || null;
                }

                setTimeout(() => {
                  if (!this.activityContainer) {
                    this.hideButtonLoading(activityBtn_button);
                    window.pqToast.showToast('error', 'Modal container not found');
                    return;
                  }

                  if (!res || res.length === 0) {
                    const tableContainer = this.activityContainer.querySelector(
                      '.pq-member-banner-activity__table-container'
                    );
                    const activityEmpty = this.activityContainer.querySelector('.pq-member-banner-activity__empty');
                    if (tableContainer) {
                      tableContainer.classList.add('hidden');
                    }
                    if (activityEmpty) {
                      activityEmpty.classList.remove('hidden');
                      activityEmpty.classList.add('flex');
                    }
                  } else {
                    const tableContainer = this.activityContainer.querySelector(
                      '.pq-member-banner-activity__table-container'
                    );
                    const activityEmpty = this.activityContainer.querySelector('.pq-member-banner-activity__empty');
                    const tbody = this.activityContainer.querySelector('tbody');
                    if (tableContainer) {
                      tableContainer.classList.remove('hidden');
                    }
                    if (activityEmpty) {
                      activityEmpty.classList.add('hidden');
                    }
                    if (tbody) {
                      tbody.innerHTML = '';
                      res.forEach((item) => {
                        this.addTableRow(item.businessName, item.pointDesc, item.createdTime, item.isLimit);
                      });
                    }
                  }
                  this.modalManager.open('activity-modal');
                  this.hideButtonLoading(activityBtn_button);
                }, 100);
              } catch (error) {
                this.hideButtonLoading(activityBtn_button);
                window.pqToast.showToast('error', window.i18n.request_failed);
              }
            });
          }

          // 添加数据示例
          addTableRow(action, points, date, isLimit) {
            const tbody = this.activityContainer.querySelector('tbody');
            const tr = document.createElement('tr');
            let pointNumber = 0;
            if (!isLimit && isLimit !== undefined) {
              pointNumber = parseInt(points.match(/-?\d+/)[0]);
            }
            const userDate = this.switchTimeZone(date);
            tr.innerHTML = `
                        <td>${userDate.toLocaleString()}</td>
     <td>${action}</td>
            ${
              isLimit
                ? `<td class="points-negative">${points}</td>`
                : `
              <td class="${pointNumber > 0 ? 'points-positive' : 'points-negative'}">
                ${points}
            </td>`
            }
       

            `;

            tbody.append(tr);
          }

          showLoading() {
            const ContentList = Array.from(this.rewardsContainer.querySelectorAll(`[data-reward-tab-content]`));
            ContentList.forEach((item) => {
              item.classList.add('hidden');
              item.classList.add('pq-member-banner-rewards__content-tab--hidden');
            });
            const emptyEl = this.rewardsContainer.querySelector('.member-redeem_empty');
            if (emptyEl) {
              emptyEl.classList.add('hidden');
            }
            const memberRedeemLoading = this.rewardsContainer.querySelector('.member-redeem_reward_loading');
            if (memberRedeemLoading) {
              memberRedeemLoading.classList.remove('hidden');
              memberRedeemLoading.classList.add('flex');
            }
            // 显示 pq-member-banner-rewards__loading
            const rewardsLoading = this.rewardsContainer.querySelector('.pq-member-banner-rewards__loading');
            if (rewardsLoading) {
              rewardsLoading.style.display = 'block';
            }
          }

          hideLoading() {
            const memberRedeemLoading = this.rewardsContainer.querySelector('.member-redeem_reward_loading');
            if (memberRedeemLoading) {
              memberRedeemLoading.classList.add('hidden');
              memberRedeemLoading.classList.remove('flex');
            }
          }

          initModal() {
            // 确保 activity-modal 已注册
            if (!this.modalManager.getModal('activity-modal')) {
              const registeredModal = this.modalManager.register('activity-modal', {
                onOpen: (container) => {
                  this.activityContainer = container;
                },
                onClose: () => {},
              });
              // 如果注册成功，立即获取内容容器
              if (registeredModal) {
                this.activityContainer = registeredModal.querySelector('.global-modal__wrapper');
              }
            } else {
              // 如果已经注册，直接获取内容容器
              const modal = this.modalManager.getModal('activity-modal');
              this.activityContainer = modal?.querySelector('.global-modal__wrapper') || null;
            }
            if (!this.modalManager.getModal('member_banner_rewards_modal')) {
              this.modalManager.register('member_banner_rewards_modal', {
                onOpen: (container) => {
                  if (!this.firstOpen) return;
                  const _this = this;
                  this.rewardsContainer = container;
                  this.firstOpen = false;
                  const memberBannerRewardsTab = Array.from(
                    this.rewardsContainer.querySelectorAll('[data-reward-tab]')
                  );
                  memberBannerRewardsTab.forEach((tabElement) => {
                    tabElement.addEventListener('click', async function () {
                      const memberBannerRewardsTabContent = _this.rewardsContainer.querySelector(
                        '.member_banner_rewards_modal_content'
                      );
                      const tab = this.getAttribute('data-reward-tab');
                      if (tab != _this.memberBannerRewardsTabs) {
                        memberBannerRewardsTab.forEach((t) => {
                          t.classList.remove('active-tab');
                        });
                        this.classList.add('active-tab');
                        _this.showLoading();
                        try {
                          const res = await _this.getMemberRewards({
                            page: 1,
                            pageSize: 999,
                            status: tab === 'available' ? 0 : tab === 'used' ? 1 : 2,
                          });

                          _this.memberBannerRewardsTabs = tab;
                          _this.hideLoading();
                          _this.renderRewardsContent(tab, res);
                          // memberBannerRewardsTabContent回到顶部
                          if (memberBannerRewardsTabContent) {
                            memberBannerRewardsTabContent.scrollTop = 0;
                          }
                        } catch (error) {
                          _this.hideLoading();
                          window.pqToast.showToast('error', error.message);
                        }
                      }
                    });
                  });
                },
                onClose: () => {},
              });
            }
          }

          closeModal() {
            const memberRedeemModal = this.querySelector('.member-redeem-modal');
            if (memberRedeemModal) {
              memberRedeemModal.classList.add('hidden');
              memberRedeemModal.classList.remove('flex');
            }
            window.pq.enableScroll();
            console.log('closeModal1');
          }

          handleScroll() {
            const memberRedeemScrollContainer = this.querySelector('.member-redeem-scroll-container');
            const memberRedeemModalBtnRedeemWrapper = this.querySelector('.member-redeem-modal-btn-redeem_wrapper');
            const memberRedeemModalBtn = this.querySelector('.member-redeem-modal-btn');
            if (
              memberRedeemScrollContainer.scrollTop + memberRedeemScrollContainer.clientHeight >=
              memberRedeemScrollContainer.scrollHeight
            ) {
              memberRedeemModalBtnRedeemWrapper.classList.add('border-t');
              memberRedeemModalBtn.style.boxShadow = 'none';
            } else {
              memberRedeemModalBtnRedeemWrapper.classList.remove('border-t');
              memberRedeemModalBtn.style.boxShadow = '0 0 4px 0px #0000001a';
            }
          }

          // 根据奖励券渲染内容
          async renderRewardsContent(tab, data) {
            if (!data) {
              return;
            }
            // 隐藏 loading
            const rewardsLoading = this.rewardsContainer.querySelector('.pq-member-banner-rewards__loading');
            if (rewardsLoading) {
              rewardsLoading.style.display = 'none';
            }
            const ContentList = Array.from(this.rewardsContainer.querySelectorAll(`[data-reward-tab-content]`));
            ContentList.forEach((item) => {
              item.classList.add('hidden');
              item.classList.add('pq-member-banner-rewards__content-tab--hidden');
            });
            const emptyEl = this.rewardsContainer.querySelector('.member-redeem_empty');
            if (data.records.length === 0) {
              if (emptyEl) {
                emptyEl.classList.remove('hidden');
                emptyEl.classList.add('flex');
              }
              return;
            } else {
              if (emptyEl) {
                emptyEl.classList.add('hidden');
              }
            }
            const ContentHtml = this.rewardsContainer.querySelector(`[data-reward-tab-content="${tab}"]`);
            if (ContentHtml) {
              // 移除所有隐藏相关的类
              ContentHtml.classList.remove('hidden');
              ContentHtml.classList.remove('pq-member-banner-rewards__content-tab--hidden');
              // 查找列表容器，优先使用新的类名，如果没有则使用旧的类名
              const rewardsListWrapper =
                ContentHtml.querySelector('.pq-member-banner-rewards__list-wrapper') ||
                ContentHtml.querySelector('.rewards-list_wrapper');
              if (rewardsListWrapper) {
                // 复制第一个奖励券，优先使用新的类名，如果没有则使用旧的类名
                const firstRewardItem =
                  rewardsListWrapper.querySelector('.pq-member-banner-rewards__item') ||
                  rewardsListWrapper.querySelector('.reward-item');
                const copyRewardItem = firstRewardItem ? firstRewardItem.cloneNode(true) : null;
                // 移除所有奖励券
                rewardsListWrapper.innerHTML = '';
                if (copyRewardItem) {
                  data.records.forEach((item) => {
                    const rewardItem = copyRewardItem.cloneNode(true);
                    const img = rewardItem.querySelector('.member-redeem-img');
                    if (img && item.icon) {
                      img.setAttribute('src', item.icon);
                      img.setAttribute('alt', item.rewardName);
                    }
                    if (img) {
                      img.addEventListener('click', () => {
                        this.code = item.discountCode;
                        const memberRedeemModal = this.querySelector('.member-redeem-modal');
                        if (memberRedeemModal) {
                          const modalTitle = memberRedeemModal.querySelector('.member-redeem-modal-title');
                          if (modalTitle) {
                            modalTitle.textContent = item.rewardName;
                          }
                          const modalPoints = memberRedeemModal.querySelector('.member-redeem-modal-points');
                          if (modalPoints) {
                            modalPoints.classList.add('hidden');
                          }
                          const modalCode = memberRedeemModal.querySelector('.member-redeem-modal-code');
                          modalCode.setAttribute('data-code', item.discountCode);
                          memberRedeemModal;
                          if (modalCode) {
                            modalCode.classList.remove('hidden');
                            const codeSpan = modalCode.querySelector('span');
                            if (codeSpan) {
                              codeSpan.textContent = `Code: ${item.discountCode}`;
                            }
                          }
                          if (item.icon) {
                            const modalImg = memberRedeemModal.querySelector('.member-redeem-modal-img');
                            if (modalImg) {
                              modalImg.setAttribute('src', item.icon);
                            }
                          }
                          const rulesEl = memberRedeemModal.querySelector('.member-redeem-rules');
                          if (rulesEl) {
                            rulesEl.innerHTML = item.rule;
                          }
                          const modalBtn = memberRedeemModal.querySelector('.member-redeem-modal-btn');
                          if (modalBtn) {
                            modalBtn.classList.remove('hidden');
                            modalBtn.classList.add('flex');
                          }
                          const modalBtnRedeemWrapper = memberRedeemModal.querySelector(
                            '.member-redeem-modal-btn-redeem_wrapper'
                          );
                          if (modalBtnRedeemWrapper) {
                            modalBtnRedeemWrapper.classList.add('hidden');
                          }
                          const modalBtnCopy = memberRedeemModal.querySelector('.member-redeem-modal-btn-copy');
                          if (modalBtnCopy) {
                            modalBtnCopy.classList.remove('hidden');
                            modalBtnCopy.classList.add('flex');
                          }
                          memberRedeemModal.classList.remove('hidden');
                          memberRedeemModal.classList.add('flex');
                          if (this.memberBannerRewardsTabs != 'available') {
                            if (modalBtnCopy) {
                              modalBtnCopy.classList.add('hidden');
                            }
                            if (rulesEl) {
                              rulesEl.innerHTML = item.rule;
                            }
                          } else {
                            this.handleScroll();
                          }
                        }
                      });
                    }
                    const title = rewardItem.querySelector('.member-redeem-title');
                    if (title) {
                      title.textContent = item.rewardName;
                    }
                    const codeSpan = rewardItem.querySelector('.member-redeem-code')?.querySelector('span');
                    if (codeSpan) {
                      codeSpan.textContent = `Code: ${item.discountCode}`;
                    }
                    const copyIcon = rewardItem.querySelector('.member-redeem-code')?.querySelector('i');
                    if (copyIcon) {
                      copyIcon.addEventListener('click', () => {
                        window.pq.copyToClipboard(item.discountCode);
                      });
                    }
                    const expiresOn = rewardItem.querySelector('.member-redeem-date');
                    if (expiresOn) {
                      if (item.expiredAt) {
                        // 将item.expiredAt转换为用户当前时区时间
                        const localTime = this.switchTimeZone(item.expiredAt);
                        expiresOn.textContent = window.i18n.member_expires_on.replace(
                          '{date}',
                          `${localTime.toLocaleDateString()}`
                        );
                      } else {
                        expiresOn.textContent = window.i18n.member_no_expiration_date;
                      }
                    }
                    rewardsListWrapper.appendChild(rewardItem);
                  });
                }
              }
            }
          }

          // 切换时区时间
          switchTimeZone(cnTime) {
            // 创建北京时间对象
            const cnDate = new Date(cnTime);

            // 获取用户时区偏移（分钟）
            const userOffset = new Date().getTimezoneOffset();

            // 将用户偏移转换为小时（注意：getTimezoneOffset 返回的是负值）
            const userOffsetHours = -userOffset / 60;

            // 计算时差（小时）
            const diffHours = 8 - userOffsetHours;

            // 转换为用户本地时间
            return new Date(cnDate.getTime() - diffHours * 60 * 60 * 1000);
          }
        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();
})();
